import React, { useState, useEffect } from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import PRODUCTS_NEW, { POSSIBLE_SUBSCRIPTION_TYPES } from '../constants/ProductsNew'
import { getDiscountsSelector } from '../reducers/discounts'
import { activeWebTrialOfferPricesSelector } from '../reducers/profile'
import SvgPack from './SvgPack'

import '../styles/subscription-select-new.scss'

const SubscriptionSelectNew = ({
  activeProduct,
  onProductChange = () => {},
  excludedTypes,
  discounts,
  activeWebTrialOfferPrices
}) => {
  const [selectedProduct, setSelectedProduct] = useState(activeProduct || 'pack_yearly')
  const pack = excludedTypes.includes('pack') ? [] : PRODUCTS_NEW.filter(item => item.type === 'pack')
  const radio = excludedTypes.includes('radio') ? [] : PRODUCTS_NEW.filter(item => item.type === 'radio')
  const kids = excludedTypes.includes('kids') ? [] : PRODUCTS_NEW.filter(item => item.type === 'kids')
  const sectionItems = { pack, radio, kids }
  const productData = PRODUCTS_NEW.filter(item => item.product === selectedProduct)[0]
  const product = productData?.type
  const bottomText = productData?.bottomText

  useEffect(() => {
    if (window.SubscriptionAnalytics) {
      window.SubscriptionAnalytics.trackSubscriptionImpressionsInProfile(!!radio.length, !!kids.length)
    }
  }, [radio.length, kids.length])

  return (
    <div className="account-product-new">
      <SvgPack />
      {POSSIBLE_SUBSCRIPTION_TYPES.map(renderSection)}
      <div className="account-product-new__bottom-text">{bottomText}</div>
    </div>
  )

  function renderSection({ type, logo, promo }, index) {
    let items = sectionItems[type]
    let trialPriceForProduct = false
    let haveDiscount = false

    if (Object.keys(discounts).length > 0) {
      // Если применен промокод ищем, действует ли он в конкретной секции
      haveDiscount = items.find(item => discounts[item.discountType])
    }

    // эта инфа приходит с бекенда и фронтенд меняет наименования на camel case, приходится искать по нему
    if (activeWebTrialOfferPrices) {
      // Если тип продукта активен
      if (productData?.type === type) {
        // то показываем "Первые две недели — за 1 рубль" когда выбрана соответствующая подписка которая есть в activeWebTrialOfferPrices
        const trialType = Object.keys(activeWebTrialOfferPrices).find(offer => offer === productData?.camelCaseId)
        trialPriceForProduct = activeWebTrialOfferPrices[trialType]
      } else {
        // Если тип продукта не активен то показываем "Первые две недели — за 1 рубль" если в items есть хотя бы один тип из activeWebTrialOfferPrices
        Object.keys(activeWebTrialOfferPrices).forEach(item => {
          trialPriceForProduct =
            items.find(productItem => item === productItem.camelCaseId) && activeWebTrialOfferPrices[item]
        })
      }
    }

    return (
      items.length > 0 && (
        <div
          key={`section__${type}__${index}`}
          id={type}
          className={classnames('account-product-new__product', {
            'account-product-new__product--active': product === type
          })}
          onClick={handleSectionClick(type)}>
          <div className="account-product-new__header">
            <div className="account-product-new__logo-container">
              <div className="account-product-new__checkbox" />
              <svg className="account-product-new__logo">
                <use href={logo} />
              </svg>
            </div>
            {trialPriceForProduct && !haveDiscount && (
              <div
                className={classnames('account-product-new__promo', {
                  'account-product-new__promo--on-border': product !== type
                })}>
                {' '}
                {trialPriceForProduct === 1
                  ? `Первые две недели — за 1 рубль`
                  : `Первый месяц — за ${trialPriceForProduct} ₽`}
              </div>
            )}
            {promo && !trialPriceForProduct && !haveDiscount && (
              <div
                className={classnames('account-product-new__promo', {
                  'account-product-new__promo--on-border': product !== type
                })}>
                <span className="account-product-new__promo--desktop">{promo.desktop}</span>
                <span className="account-product-new__promo--mobile"> {promo?.mobile}</span>
              </div>
            )}
          </div>
          <div className="account-product-new__items">
            {items.map(renderItem(trialPriceForProduct, haveDiscount, product === type))}
          </div>
        </div>
      )
    )
  }

  function renderItem(trialPriceForProduct, haveDiscount, isSelected) {
    return ({ type, camelCaseId, price, title, product, badgeLeft, badgeRight, discountType }) => {
      const discount = (discounts[discountType] || 0) / 100
      const showBadgeIfMonthly = selectedProduct.includes('monthly')

      return (
        <div
          key={camelCaseId}
          onClick={handleClickOrPayment(type, product)}
          className={classnames('account-product-new__item', {
            'account-product-new__item--active': product === selectedProduct
          })}>
          {!isSelected ? (
            renderBadges({ haveDiscount, isSelected, badgeLeft, badgeRight })
          ) : (
            <>{showBadgeIfMonthly && renderBadges({ haveDiscount, isSelected, badgeLeft, badgeRight })}</>
          )}
          <span className="account-product-new__price">{renderPrice(price, discount, badgeLeft || badgeRight)}</span>
          <span className="account-product-new__title">{title}</span>
        </div>
      )
    }
  }

  function renderPrice(price, discount) {
    if (discount) {
      return (
        <span className="account-product-new__price--discount">
          <span className="account-product-new__old-price account-product-new__price--discount-old-price">{price}</span>
          <span className="account-product-new__price">{price - discount}</span> ₽
        </span>
      )
    } else {
      return <span className="account-product-new__price ">{price - discount} ₽</span>
    }
  }

  function renderBadges({ haveDiscount, isSelected, badgeLeft, badgeRight }) {
    return (
      <>
        {!haveDiscount && renderBadge(isSelected)(badgeLeft)}
        {!haveDiscount && renderBadge(isSelected, badgeRight)(badgeRight)}
      </>
    )
  }

  function renderBadge(isSelected, isRight) {
    return badge => {
      if (!badge) return
      const { desktop, mobile } = badge

      return (
        <>
          {!isSelected && mobile && (
            <span
              className={classnames(
                'account-product-new__badge account-product-new__badge-mobile',
                {
                  'account-product-new__badge--left': !isRight
                },
                {
                  'account-product-new__badge--right': isRight
                }
              )}>
              {mobile}
            </span>
          )}
          {desktop && (
            <span
              className={classnames(
                'account-product-new__badge account-product-new__badge-desktop',
                {
                  'account-product-new__badge--left': !isRight
                },
                {
                  'account-product-new__badge--right': isRight
                }
              )}>
              {desktop}
            </span>
          )}
        </>
      )
    }
  }

  function handleSectionClick(type) {
    return () => {
      setSelectedProduct(type === 'radio' ? 'monthly' : `${type}_monthly`)
      onProductChange(type, type === 'radio' ? 'monthly' : `${type}_monthly`)
    }
  }

  function handleClickOrPayment(type, product) {
    return event => {
      event.stopPropagation()
      setSelectedProduct(product)
      onProductChange(type, product)
    }
  }
}

const mapStateToProps = createStructuredSelector({
  discounts: getDiscountsSelector,
  activeWebTrialOfferPrices: activeWebTrialOfferPricesSelector
})

export default connect(mapStateToProps)(React.memo(SubscriptionSelectNew))
